import { FC, SVGProps } from 'react';

export const LoaderIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16 2.53333C16.81 2.53333 17.4667 3.18997 17.4667 3.99999V7.99999C17.4667 8.81001 16.81 9.46666 16 9.46666C15.19 9.46666 14.5333 8.81001 14.5333 7.99999V3.99999C14.5333 3.18997 15.19 2.53333 16 2.53333ZM25.5704 6.42957C26.1432 7.00234 26.1432 7.93098 25.5704 8.50375L22.7037 11.3704C22.131 11.9432 21.2023 11.9432 20.6296 11.3704C20.0568 10.7976 20.0568 9.86901 20.6296 9.29624L23.4962 6.42957C24.069 5.8568 24.9976 5.8568 25.5704 6.42957ZM22.5333 16C22.5333 15.19 23.19 14.5333 24 14.5333H28C28.81 14.5333 29.4667 15.19 29.4667 16C29.4667 16.81 28.81 17.4667 28 17.4667H24C23.19 17.4667 22.5333 16.81 22.5333 16ZM20.6296 20.6296C21.2023 20.0568 22.131 20.0568 22.7037 20.6296L25.5704 23.4962C26.1432 24.069 26.1432 24.9976 25.5704 25.5704C24.9976 26.1432 24.069 26.1432 23.4962 25.5704L20.6296 22.7038C20.0568 22.131 20.0568 21.2023 20.6296 20.6296ZM16 22.5333C16.81 22.5333 17.4667 23.19 17.4667 24V28C17.4667 28.81 16.81 29.4667 16 29.4667C15.19 29.4667 14.5333 28.81 14.5333 28V24C14.5333 23.19 15.19 22.5333 16 22.5333Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M6.42909 6.4297C7.00186 5.85693 7.9305 5.85693 8.50327 6.4297L11.3699 9.29637C11.9427 9.86913 11.9427 10.7978 11.3699 11.3705C10.7972 11.9433 9.86852 11.9433 9.29576 11.3705L6.42909 8.50388C5.85632 7.93111 5.85632 7.00247 6.42909 6.4297Z"
			fill="currentColor"
			fillOpacity="0.1"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2.53333 16C2.53333 15.19 3.18997 14.5333 3.99999 14.5333H7.99999C8.81001 14.5333 9.46666 15.19 9.46666 16C9.46666 16.81 8.81001 17.4667 7.99999 17.4667H3.99999C3.18997 17.4667 2.53333 16.81 2.53333 16Z"
			fill="currentColor"
			fillOpacity="0.4"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.3699 20.6296C11.9427 21.2024 11.9427 22.131 11.3699 22.7038L8.50327 25.5704C7.9305 26.1432 7.00186 26.1432 6.42909 25.5704C5.85632 24.9977 5.85632 24.069 6.42909 23.4963L9.29576 20.6296C9.86852 20.0568 10.7972 20.0568 11.3699 20.6296Z"
			fill="currentColor"
		/>
	</svg>
);
